import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsEdit from '../../api/ManualPreadviceTransactionsEditAPI';
import { MPA_TRANSACTIONS_EDIT_REQUEST } from '../actions/types/ManualPreadviceTransactionsEditActionTypes';
import { putManualPreadviceTransactionsEditSuccessActionCreator, putManualPreadviceTransactionsEditFailureActionCreator } from '../actions/ManualPreadviceTransactionsEditActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doMpaTransactionsEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchManualPreadviceTransactionsEdit, action.payload);
    yield put(putManualPreadviceTransactionsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.manualpreadvicetransactions.edit.success'),
    }));
  } catch (error) {
    yield put(putManualPreadviceTransactionsEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doMpaTransactionsEditWatcher() {
  yield takeLatest(MPA_TRANSACTIONS_EDIT_REQUEST, doMpaTransactionsEditWorker);
}

export default doMpaTransactionsEditWatcher;
